module.exports = __webpack_public_path__ + "img/camera.b8fd22a3.png";